import React, { useState, useEffect, useContext } from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'

import Topbar from './Topbar';
import Map from './MapWindow';
import PlainTopbar from './PlainTopbar';
import PlainFooter from './PlainFooter';
import PasswordReset from './PasswordResetInterface';

import ReactLoading from 'react-loading';
import ErrorDialog from "../components/ErrorDialog";

import { SessionContext } from "../context/session-context";
import { MessageContext } from "../context/message-context";
import { UserContext } from "../context/user-context";
import { findAllByDisplayValue } from '@testing-library/react';

var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

const useStyles = makeStyles({
  root: {
    minWidth: 1130,
    minHeight: 600,
    background: 'white',
    color: 'white',
  },
})

export default function UserInterface(props) {

    const classes = useStyles();
    const {isLogin, isRegister, isForgotten, isDemo} = props;
    const [sState, sDispatch] = useContext(SessionContext);
    const [mState] = useContext(MessageContext);
    const [isStandard, setIsStandard] = useState(true);
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [resetIdent, setResetIdent] = useState('');

    /**
    * Store global settings.
    */
   useEffect(() => {
    sDispatch({
      type: "setSystemConfig",
      payload: { 
        copyright:process.env.REACT_APP_MAP_COPYRIGHT+ ' '+ new Date().getFullYear()
      }
    });

    //Checks url for params.
    //http://localhost:3000/?resetid=1234324rew34
    let search = window.location.search;
    let params = new URLSearchParams(search);

    //Checks for password reset
    let resetIdent = params.get('resetid');
    if (typeof resetIdent !== 'undefined' && resetIdent !== null){
      setIsPasswordReset(true);
      setResetIdent(resetIdent);
      setIsStandard(false);
      //console.log("resetid = "+resetIdent);
    } else {
      setIsStandard(true);
      setIsPasswordReset(false);
      setResetIdent('');
    }

  }, []);

    const handlePasswordResetClose=()=>{
      setIsStandard(true);
      setIsPasswordReset(false);
      setResetIdent('');
    }

    //<Map errorDisplay={this.displayError} active={this.state.isActive} updateBalance={this.updateBalance} />
    //<ErrorDialog setOpen={this.state.viewErrorDialog} title={this.state.errorTitle} message={this.state.errorMessage} errorDisplay={this.displayError}/>
    //
    return (
      <div className={classes.root}>
        <Grid container>
            <Grid item xs={12}>
              {isStandard ? <div>
                  <Topbar isLogin={isLogin ?? false} isRegister={isRegister ?? false} isForgotten={isForgotten ?? false} isDemo={isDemo ?? false} />
                  <Map />
              </div> : ''}
              {isPasswordReset ? <div>
                  <PlainTopbar/>
                  <PasswordReset ident={resetIdent} open={isPasswordReset} close={handlePasswordResetClose} />
                  <PlainFooter />
              </div> : ''}
            </Grid>
        </Grid>
      </div>
  
    );
  }